import { StudentCountsInShapeColorByEnum } from "@/providers/store/api/shapes/enums/student-counts-in-shape.enum";

export type SummaryMetricKind =
  | "students"
  | "grades"
  | "schools-attended"
  | "schools-plotted"
  | "schools";

export interface SummaryMetricDefinition {
  kind: SummaryMetricKind;
  label: string;
  value: number;
  /** When true, spans full grid width on 2-column layouts (Students for school/none). */
  fullWidthOnWide?: boolean;
}

export type SummaryMetricsLayout = "single" | "students-over-schools" | "grade-grid";

export interface BuildSummaryMetricsInput {
  schoolCountsOnly: boolean;
  type: StudentCountsInShapeColorByEnum;
  studentsCount: number;
  dataCount: number;
  schoolsCount: number;
  schoolsPlotted: number;
}

export interface BuildSummaryMetricsResult {
  layout: SummaryMetricsLayout;
  metrics: SummaryMetricDefinition[];
}

export function buildSummaryMetrics({
  schoolCountsOnly,
  type,
  studentsCount,
  dataCount,
  schoolsCount,
  schoolsPlotted,
}: BuildSummaryMetricsInput): BuildSummaryMetricsResult {
  if (schoolCountsOnly) {
    return {
      layout: "single",
      metrics: [
        {
          kind: "schools",
          label: "Schools plotted",
          value: schoolsCount,
        },
      ],
    };
  }

  if (type === StudentCountsInShapeColorByEnum.GRADE) {
    return {
      layout: "grade-grid",
      metrics: [
        {
          kind: "students",
          label: "Students",
          value: studentsCount,
        },
        {
          kind: "grades",
          label: "Grades",
          value: dataCount,
        },
        {
          kind: "schools-attended",
          label: "Schools attended",
          value: schoolsCount,
        },
        {
          kind: "schools-plotted",
          label: "Schools plotted",
          value: schoolsPlotted,
        },
      ],
    };
  }

  return {
    layout: "students-over-schools",
    metrics: [
      {
        kind: "students",
        label: "Students",
        value: studentsCount,
        fullWidthOnWide: true,
      },
      {
        kind: "schools-attended",
        label: "Schools attended",
        value: schoolsCount,
      },
      {
        kind: "schools-plotted",
        label: "Schools plotted",
        value: schoolsPlotted,
      },
    ],
  };
}
